import { render, staticRenderFns } from "./IconAwardFlag.vue?vue&type=template&id=12c27518"
import script from "./IconAwardFlag.vue?vue&type=script&lang=js"
export * from "./IconAwardFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports